module.exports = __webpack_public_path__ + "static/media/salesforce-video.93479715.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/salesforce-video.png
// module id = yk+7
// module chunks = 89